import { render, staticRenderFns } from "./FactorItem.vue?vue&type=template&id=2b51da10&"
import script from "./FactorItem.vue?vue&type=script&lang=js&"
export * from "./FactorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports